import styles from '../styles/Sidebar.module.sass';

import { FC, SyntheticEvent, useState } from 'react';
import { Nav, Sidenav } from 'rsuite';
import { Link } from "react-router-dom";
import { IRoute } from 'utils/routes';

export interface NavProps {
  routes: IRoute[];
  activeKey: string;
  onSelect: (eventKey: string, event?: SyntheticEvent<Element, Event>) => void;
}

const NavMenu: FC<NavProps> = ({ routes, ...props }) => {
  const [expanded, setExpanded] = useState(true);
  const [image, setImage] = useState("/media/logo-navbar.svg");
  const [width, setWidth] = useState("260px");

  const renderNav = routes.map(route => (
    <Nav.Item
      className={props.activeKey == route.path ? styles.itemActive : styles.item}
      eventKey={route.path}      
      as={Link}
      to={route.path}
      key={route.id}
    >
      { route.label }
    </Nav.Item>
  ));

  return (
    <Sidenav
      className={styles.sidebar} expanded={expanded} style={{'width': width}}
    >
      <Sidenav.Header style={{
        textAlign: 'center',
        height: '70px',
        padding: '20px 20px 20px 70px'
      }}>
        <Link to="/" onClick={()=>props.onSelect("/")}>
          <img src={image} alt="Logo AMSA" />
        </Link>
      </Sidenav.Header>
      <Sidenav.Body>
        <Nav {...props}>
          { renderNav }
        </Nav>
      </Sidenav.Body>
    </Sidenav>
  );
};

export default NavMenu;